import { useLandingPageTranslation } from '@components/goals/goal-landing-page/useLandingPageTranslation';
import { formatDateNumeric } from '@datetime';
import ClockIcon from '@icons/ClockIcon';
import { setupForDark } from '@theme';
import classNames from 'classnames';

/**
 * "startujemy 03.04.2026" chip shown for pre-sale goals so learners know when the
 * goal launches. Uses the landing-page translation (locked to PL like the cards it
 * appears on).
 */
export default function GoalPreSaleReleaseChip({
  releaseDate,
  className
}: {
  releaseDate: Date;
  className?: string;
}) {
  const { t } = useLandingPageTranslation();
  return (
    <div
      className={classNames(
        'flex items-center gap-xxs w-max rounded-md px-xs py-xxs P5M border-[1px]',
        setupForDark('bg-primary text-primary border-primary'),
        className
      )}
    >
      <ClockIcon size={14} />
      <span className='text-nowrap'>
        {t('domains.goals.sellingStatus.startsOn', { date: formatDateNumeric(releaseDate) })}
      </span>
    </div>
  );
}
